// assets/custom.js — v6
// Arquitectura: trabajar CON theme.js, no contra él.
// Módulos: Mobile Search Overlay + FutureBlink Price Formatter
// Placeholder ahora se define en locales/es.json (sin JS).

/* ===========================
   MOBILE SEARCH OVERLAY — v5
   =========================== */
(function() {
  var wrapper = document.querySelector('.header__search-bar-wrapper');
  if (!wrapper) return;

  var isMutating = false;

  // ── Abrir overlay ──
  function openOverlay() {
    if (window.innerWidth >= 1000) return;

    isMutating = true;

    // 1. Posición debajo del header
    var header = wrapper.closest('.header');
    var top = header ? Math.round(header.getBoundingClientRect().bottom) : 64;

    // 2. Activar is-fixed
    wrapper.classList.add('is-fixed');

    // 3. Wrapper: full width, fondo transparente, sin padding del tema
    wrapper.style.setProperty('top', top + 'px', 'important');
    wrapper.style.setProperty('height', 'calc(100vh - ' + top + 'px)', 'important');
    wrapper.style.setProperty('left', '0', 'important');
    wrapper.style.setProperty('width', '100%', 'important');
    wrapper.style.setProperty('padding', '0', 'important');
    wrapper.style.setProperty('background', 'rgba(0,0,0,0.3)', 'important');
    wrapper.style.setProperty('z-index', '10');
    wrapper.style.setProperty('overflow-y', 'auto');

    // 4. Search bar: full width, fondo blanco
    var searchBar = wrapper.querySelector('.search-bar');
    if (searchBar) {
      searchBar.style.setProperty('opacity', '1', 'important');
      searchBar.style.setProperty('transition-delay', '0s', 'important');
      searchBar.style.setProperty('width', '100%', 'important');
      searchBar.style.setProperty('max-width', 'none', 'important');
      searchBar.style.setProperty('margin', '0', 'important');
      searchBar.style.setProperty('padding', '16px 20px 12px', 'important');
      searchBar.style.setProperty('background', '#fff', 'important');
      searchBar.style.setProperty('border-radius', '0', 'important');
      searchBar.style.setProperty('box-shadow', 'none', 'important');
      searchBar.style.setProperty('box-sizing', 'border-box');
    }

    // 5. Input más grande para +50
    var input = wrapper.querySelector('.search-bar__input');
    if (input) {
      input.style.setProperty('font-size', '18px', 'important');
      input.style.setProperty('padding', '14px 16px', 'important');
      input.style.setProperty('min-height', '52px', 'important');
    }

    // 6. Ocultar "Cerrar" del tema
    var themeClose = wrapper.querySelector('.search-bar__close-button');
    if (themeClose) themeClose.style.setProperty('display', 'none', 'important');

    // 7. Bloquear scroll
    document.body.classList.add('no-mobile-scroll');

    // 8. Autofocus
    if (input && document.activeElement !== input) {
      setTimeout(function() { input.focus(); }, 50);
    }

    isMutating = false;
  }

  // ── Cerrar overlay ──
  function closeSearch() {
    isMutating = true;

    // 1. Blur input + limpiar estilos
    var input = wrapper.querySelector('.search-bar__input');
    if (input) {
      input.blur();
      input.style.removeProperty('font-size');
      input.style.removeProperty('padding');
      input.style.removeProperty('min-height');
    }

    // 2. Limpiar wrapper
    wrapper.classList.remove('is-fixed');
    wrapper.style.removeProperty('top');
    wrapper.style.removeProperty('height');
    wrapper.style.removeProperty('left');
    wrapper.style.removeProperty('width');
    wrapper.style.removeProperty('padding');
    wrapper.style.removeProperty('background');
    wrapper.style.removeProperty('z-index');
    wrapper.style.removeProperty('overflow-y');

    // 3. Limpiar search bar
    var searchBar = wrapper.querySelector('.search-bar');
    if (searchBar) {
      searchBar.style.removeProperty('opacity');
      searchBar.style.removeProperty('transition-delay');
      searchBar.style.removeProperty('width');
      searchBar.style.removeProperty('max-width');
      searchBar.style.removeProperty('margin');
      searchBar.style.removeProperty('padding');
      searchBar.style.removeProperty('background');
      searchBar.style.removeProperty('border-radius');
      searchBar.style.removeProperty('box-shadow');
      searchBar.style.removeProperty('box-sizing');
    }

    // 4. Desbloquear scroll
    document.body.classList.remove('no-mobile-scroll');

    // 5. Restaurar "Cerrar" del tema
    var themeClose = wrapper.querySelector('.search-bar__close-button');
    if (themeClose) themeClose.style.removeProperty('display');

    // 6. Limpiar estados del tema
    var searchBarEl = wrapper.querySelector('.search-bar');
    if (searchBarEl) searchBarEl.classList.remove('is-expanded');
    var results = wrapper.querySelector('.search-bar__results');
    if (results) results.setAttribute('aria-hidden', 'true');
    var menu = wrapper.querySelector('.search-bar__menu-wrapper');
    if (menu) menu.setAttribute('aria-hidden', 'true');

    // 7. Sincronizar con theme.js
    var toggleBtn = document.querySelector('[data-action="toggle-search"]');
    if (toggleBtn) {
      toggleBtn.click();
    } else {
      wrapper.classList.remove('is-visible');
      var headerEl = wrapper.closest('.header');
      if (headerEl) headerEl.classList.remove('header--search-expanded');
    }

    isMutating = false;
  }

  // ── MutationObserver ──
  var obs = new MutationObserver(function() {
    if (isMutating) return;

    // Desktop: el tema bloquea scroll con no-mobile-scroll — quitarlo
    if (window.innerWidth >= 1000) {
      document.body.classList.remove('no-mobile-scroll');
      return;
    }

    var isOpen = wrapper.classList.contains('is-visible') ||
                 wrapper.classList.contains('is-fixed');

    if (isOpen && !wrapper.classList.contains('is-fixed')) {
      openOverlay();
    }
  });

  obs.observe(wrapper, { attributes: true, attributeFilter: ['class'] });

  // ── Tap fuera del search bar cierra el overlay ──
  document.addEventListener('click', function(e) {
    if (!wrapper.classList.contains('is-fixed')) return;
    if (window.innerWidth >= 1000) return;
    if (e.target.closest('[data-action="toggle-search"]')) return;
    if (e.target.closest('.search-bar')) return;
    closeSearch();
  });

  // ── Escape cierra (solo mobile) ──
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && wrapper.classList.contains('is-fixed')) {
      if (window.innerWidth >= 1000) return;
      closeSearch();
    }
  });
})();

/* ===========================
   FORMATEO DE PRECIOS — FutureBlink
   =========================== */
(function() {
  function formatearPrecios() {
    const elems = document.querySelectorAll('.futureblink-price-text');
    elems.forEach(function(el) {
      const texto = el.textContent || '';
      const match = texto.match(/(\d+)(?:[.,](\d+))?/);
      if (!match) return;
      const entero = match[1];
      const fract = match[2] || '';

      // Formatea miles con punto
      const chars = entero.split('').reverse();
      const grouped = [];
      for (let i = 0; i < chars.length; i++) {
        grouped.push(chars[i]);
        if ((i + 1) % 3 === 0 && i + 1 !== chars.length) {
          grouped.push('.');
        }
      }
      const parteEntera = grouped.reverse().join('');

      // Construir resultado final
      const salida = fract && fract !== '00'
        ? `$${parteEntera}.${fract.padEnd(2, '0')}`
        : `$${parteEntera}`;

      if (el.textContent !== salida) {
        el.textContent = salida;
      }
    });
  }

  // 1. MutationObserver con throttle (máx 1 ejecución cada 500ms)
  let moTimer = null;
  const observer = new MutationObserver(function() {
    if (moTimer) return;
    moTimer = setTimeout(function() { moTimer = null; formatearPrecios(); }, 500);
  });
  document.addEventListener('DOMContentLoaded', function() {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    formatearPrecios();
  });

  // 2. Eventos Shopify
  document.documentElement.addEventListener('product:added', formatearPrecios);
  document.documentElement.addEventListener('cart:change',   formatearPrecios);
  document.documentElement.addEventListener('cart:refresh',  formatearPrecios);

  // El MutationObserver + eventos Shopify ya cubren todos los casos.
  // setInterval eliminado: causaba 10 ejecuciones/segundo innecesarias.
})();

/* ===========================
   REORDEN MÓVIL "Directo desde bodega" — v1
   Móvil (<=999px): baja el carrusel de videos debajo del botón
   "Agregar al carrito" (fin de --info) y por encima de "Método de Envío".
   Desktop: permanece bajo la galería (columna izq.); el DOM original ya
   es correcto ahí, así que es no-op.
   Reposiciona tras el reemplazo DOM de product-rerender (cambio de variante).
   =========================== */
(function() {
  var MQ = window.matchMedia('(max-width:999px)');

  function placeIn(section) {
    var vnc = section.querySelector('.product-block-list__item--video-news');
    if (!vnc) return;
    var info = section.querySelector('.product-block-list__item--info');
    var gallery = section.querySelector('.product-block-list__item--gallery');
    if (MQ.matches) {
      // Móvil: justo después de --info (bajo "agregar productos"),
      // antes de "Método de Envío" y demás bloques de contenido.
      if (info && info.nextElementSibling !== vnc) {
        info.insertAdjacentElement('afterend', vnc);
      }
    } else {
      // Desktop: restaurar bajo la galería.
      if (gallery && gallery.nextElementSibling !== vnc) {
        gallery.insertAdjacentElement('afterend', vnc);
      }
    }
  }

  function placeAll() {
    var sections = document.querySelectorAll('section[data-section-type="product"]');
    for (var i = 0; i < sections.length; i++) placeIn(sections[i]);
  }

  function init() {
    var sections = document.querySelectorAll('section[data-section-type="product"]');
    if (!sections.length) return; // no es página de producto
    placeAll();
    // Reposicionar tras el rerender de variante. placeIn es no-op si ya está
    // bien ubicado, por lo que el observer no entra en bucle.
    for (var i = 0; i < sections.length; i++) {
      try {
        new MutationObserver(placeAll).observe(sections[i], { childList: true, subtree: true });
      } catch (e) {}
    }
    (MQ.addEventListener ? MQ.addEventListener('change', placeAll) : MQ.addListener(placeAll));
    document.addEventListener('variant:change', function() { setTimeout(placeAll, 0); }, { passive: true });
    document.addEventListener('shopify:section:load', function() { setTimeout(placeAll, 0); }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
